import React , {forwardRef, useImperativeHandle, useRef, useState} from 'react'
import Modal from 'react-bootstrap/Modal'

const Modals_Load = forwardRef((props, ref) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useImperativeHandle(ref, () => ({
        fnshow() {                    
          handleShow();
        },
        fnclose() {          
          handleClose();
        },
      }));

return (
<div>
<Modal
    show={show}
    onHide={handleClose}
    backdrop="static"
    keyboard={false}
    fullscreen={false}
  >
    <Modal.Header>
      <Modal.Title>โปรดรอสักครู่</Modal.Title>
    </Modal.Header>
    <Modal.Body>
                    
    <div class="d-flex align-items-center">
    <h4><strong>Please waiting&nbsp;...&nbsp;&nbsp;</strong></h4>
    {/* <i class="fa fa-spinner fa-spin" style={{fontSize: '35px'}}></i> */}
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"  style={{fontSize: '35px'}}></i>
    {/* <div class="spinner-border text-warning ml-auto" role="status" aria-hidden="true"></div> */}
    
    
    </div>
     
    </Modal.Body>
    <Modal.Footer>      
    </Modal.Footer>
  </Modal>
</div>

);

});

export default Modals_Load


